import React, {memo} from 'react'
import cx from 'classnames'

/* Styles */
import s from './product-card.scss'

const STAR_COUNT = 5

const activeStars = [...Array(STAR_COUNT)].map((_, index) => <span key={index} className={s.activeStar} />)
const defaultStars = [...Array(STAR_COUNT)].map((_, index) => <span key={index} className={s.defaultStar} />)

const Rating = memo(({rate}) => (
  <div className={s.rating}>
    <div className={s.starsWrapper}>
      {defaultStars}
    </div>
    <div className={cx(s.starsWrapper, s.active)} style={{width: `${rate * 20}%`}}>
      {activeStars}
    </div>
  </div>
))

export default Rating
